module.exports = __webpack_public_path__ + "img/75.9923aef6.png";